import React from 'react'
import { ExternalLink, Tooltip, Text, Heading } from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { useTranslation } from 'react-i18next'

export const TooltipApostille: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Tooltip
      ariaToggleButtonLabelText={t(
        'orderWizardPriceListApostilleTooltipAriaLabelToggle'
      )}
      ariaCloseButtonLabelText={t(
        'orderWizardPriceListApostilleTooltipAriaLabelClose'
      )}
    >
      <Heading variant="h5">
        <LocalizedString stringKey="orderWizardPriceListApostilleTooltipHeader" />
      </Heading>
      <Text>
        <LocalizedString stringKey="orderWizardPriceListApostilleTooltipBody" />
      </Text>
      <br />
      <ExternalLink
        href={t(
          'orderWizardAdditonalSelectionsStepApostilleSelectionTextLinkHref'
        )}
        labelNewWindow={t('opensInNewWindow')}
        smallScreen
        underline="initial"
      >
        <LocalizedString stringKey="orderWizardPriceListApostilleTooltipReadMoreLinkText" />
      </ExternalLink>
    </Tooltip>
  )
}
